import script from "./AnnualHealthAssessmentFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnualHealthAssessmentFormView.vue?vue&type=script&setup=true&lang=js"

import "./AnnualHealthAssessmentFormView.vue?vue&type=style&index=0&id=20345687&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20345687"]])

export default __exports__